// src/components/projectDetails/RepoActivation.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
// Helper: parse query parameters from URL
const useQuery = () => new URLSearchParams(useLocation().search);

const RepoActivation = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const token = localStorage.getItem("access_token");
  // Extract query parameters from the URL:
  const installation_id = query.get("installation_id");
  const setup_action = query.get("setup_action");

  // Capture the invoked project id from local storage (set in the previous step)
  const project_id = localStorage.getItem("invoked_project_id");

  const [statusMessage, setStatusMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  // On mount, call the backend API to trigger processing of activation
  useEffect(() => {
    if (!installation_id || !project_id) return;
    // Prepare payload (user_id is omitted per your instruction)
    const payload = {
      project_id,
      installation_id,
      setup_action,
    };
    fetch(
      `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github/setup-project-repository`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setStatusMessage(data.message);
        setAlertSeverity(data.success ? "success" : "error");
      })
      .catch((err) => {
        console.error("Error in setup-project-repository:", err);
        setStatusMessage("Error processing activation.");
        setAlertSeverity("error");
      });
  }, [installation_id, project_id, setup_action]);

  return (
    <Paper sx={{ p: 2, maxWidth: 600, margin: "20px auto" }}>
      <Typography variant="h6" gutterBottom>
        Activate Your GitHub Repository
      </Typography>
      <Typography variant="body1">Project ID: {project_id}</Typography>
      <Typography variant="body1">
        Installation ID: {installation_id}
      </Typography>
      <Typography variant="body1">Setup Action: {setup_action}</Typography>
      {statusMessage && (
        <Alert severity={alertSeverity} sx={{ mt: 2 }}>
          {statusMessage}
        </Alert>
      )}
      {alertSeverity === "success" ? (
        <Box sx={{ mt: 2 }}>
          <Button variant="outlined" onClick={() => window.close()}>
            You can close this tab and return to previous page.
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={24} />
        </Box>
      )}
    </Paper>
  );
};

export default RepoActivation;
